// ─────────────────────────────────────────────────────────────────────────────
// Types de cartes de compétence — miroir client de
// server/profile/competencyCardTypes.ts (rootDir=./server interdit l'import
// croisé). La parité des deux listes est verrouillée par
// server/repositories/competencyCards.test.ts. Libellés FR/EN :
// gest:competencyCards.types.<code>.
// ─────────────────────────────────────────────────────────────────────────────

export const COMPETENCY_CARD_TYPES = [
  'stc-ins',
  'stc-sup',
  'stc-ges',
  'asp',
  'signaleur-ontario',
  'sst-4-etapes',
  'acces-phd',
  'simdut-2015',
] as const

export type CompetencyCardType = (typeof COMPETENCY_CARD_TYPES)[number]

/** Jours avant l'échéance sous lesquels une carte approuvée est « à renouveler ». */
export const EXPIRY_WARNING_DAYS = 30

export type CardStanding = 'rejected' | 'pending' | 'expired' | 'expiring' | 'valid'

/**
 * État affiché d'une carte : la revue d'abord (refusée, en attente), puis
 * l'échéance d'une carte approuvée. `today` au format AAAA-MM-JJ (comparaison
 * lexicale de dates ISO, sans fuseau).
 */
export function cardStanding(
  card: { reviewStatus: 'pending' | 'approved' | 'rejected'; expiresOn: string | null },
  today: string,
): CardStanding {
  if (card.reviewStatus === 'rejected') return 'rejected'
  if (card.reviewStatus === 'pending') return 'pending'
  if (!card.expiresOn) return 'valid'
  if (card.expiresOn < today) return 'expired'
  const limit = new Date(`${today}T00:00:00Z`)
  limit.setUTCDate(limit.getUTCDate() + EXPIRY_WARNING_DAYS)
  return card.expiresOn <= limit.toISOString().slice(0, 10) ? 'expiring' : 'valid'
}
